import { getCurrencyFormat } from '../../common/utils/functions/currency'
export const detalleNominaAdapter = (rawData) => {
  const { data } = rawData.data
  if (data?.length > 0) {
    const rows = data?.map((item) => {
      const {
        ID,
        ID_NOMINA,
        NRO_FILA,
        NRO_DOC,
        TIP_DOC,
        CUIL,
        NOMBRE,
        SEXO,
        DIAS_TRABAJADOS,
        FEC_NAC,
        SUELDO,
        ERRORES,
      } = item
      return {
        id: ID,
        id_nomina: ID_NOMINA,
        nro_fila: NRO_FILA,
        nro_doc: NRO_DOC || '',
        tip_doc: TIP_DOC || '',
        cuil: CUIL || '',
        nombre: NOMBRE || '',
        sexo: SEXO || '',
        cant_dias_trabajados: DIAS_TRABAJADOS || '',
        fec_nac: FEC_NAC || '',
        sueldo: getCurrencyFormat({ value: SUELDO }),
        erroresRaw: ERRORES,
        errores: errorAdapter(ERRORES),
        sac: '',
        acciones: 'acciones',
        flag: null,
      }
    })
    return { rows: rows }
  }
  return { rows: [] }
}

const errorAdapter = (errors) => {
  const mensajes = errors.errores?.flatMap((e) => e.errores)
  const resultado = mensajes.join(' \n ')
  return resultado
}

export const resumenNominaAdapter = (rawData) => {
  const { data } = rawData.data
  const response = {
    empleados: data?.EMPLEADOS,
    masa_salarial: getCurrencyFormat({ value: data?.MASA_SALARIAL }),
    salario_promedio: getCurrencyFormat({ value: data?.SALARIO_PROMEDIO }),
    ffep: getCurrencyFormat({ value: data?.FFEP }),
    devengado_cuota: getCurrencyFormat({ value: data?.DEVENGADO_CUOTA }),
    total_a_pagar: getCurrencyFormat({ value: data?.TOTAL_A_PAGAR }),
    puede_validar: data?.PUEDE_VALIDAR,
  }
  return response
}
